// Base
import parse from "html-react-parser";

// Components
import Box from "@/components/Box";

// Store
import { useTemplateStore } from "@/zustand/templateStore";
import type { TemplateStore } from "@/types/types";

interface CustomerAssuranceItem {
  icon: string;
  tr_title: string;
  tr_description: string;
}

interface CustomerAssuranceProps {
  className?: string;
}

export default function CustomerAssurance({
  className,
}: CustomerAssuranceProps) {
  const { customerAssurance, settings } = useTemplateStore() as Pick<
    TemplateStore,
    "customerAssurance" | "settings"
  >;

  if (!customerAssurance) return null;

  const list = customerAssurance?.customer_assurance_list;
  if (!Array.isArray(list)) return null;

  return (
    <Box
      className={`${className} shadow-cc gap-4 p-3 md:px-4 md:py-6 ${
        !customerAssurance.rounded_borders ? "rounded-none" : ""
      }`}
    >
      {list.map((item: CustomerAssuranceItem, index: number) => (
        <div key={index} className="flex gap-4">
          <img
            src={item.icon}
            alt={item.tr_title}
            className="size-10 md:size-15"
          />
          <div className="flex flex-col gap-2">
            <div
              className={`text-sm font-bold md:text-base ${
                settings.enable_high_contrast
                  ? "text-cc-dark-gray"
                  : "text-cc-gray"
              }`}
            >
              {item.tr_title}
            </div>

            <div
              className={`text-xs ${
                settings.enable_high_contrast
                  ? "text-cc-gray-6"
                  : "text-cc-gray-2"
              }`}
            >
              {parse(item.tr_description)}
            </div>
          </div>
        </div>
      ))}
    </Box>
  );
}
